<template>
  <div class="m-form-stepper">
    <span class="m-form-stepper__cell m-form-stepper__cell--detail m-form-stepper__cell--primary">{{ formTitle.toUpperCase() }}</span>

    <div class="m-form-stepper__title">
      <span class="m-form-stepper__cell">
        <h1 class="a-title-huge a-title-huge--800 a-title-huge--no-margin-top a-title-huge--no-margin-bottom">{{ stepTitle }}</h1>
      </span>
      <span class="m-form-stepper__cell m-form-stepper__cell--detail m-form-stepper__cell--align-title">
        {{ $t('form-stepper-step-number-on-total-steps', { step: step, nbSteps: nbSteps }).toUpperCase() }}
      </span>
    </div>
    
    <div class="m-form-stepper__cell m-form-stepper__cell--rectangle-grid">
      <div
        v-for="index in nbSteps"
        :key="index"
        class="m-form-stepper__rectangle"
        :style="{ backgroundColor: stepColor(index), width: rectangleWidth, borderLeftWidth: getBorderLeft(index), borderRightWidth: getBorderRight(index) }"
      />
    </div>
    
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      required: true
    },
    nbSteps: {
      type: Number,
      required: true
    },
    stepTitle: {
      type: String,
      required: true
    },
    formTitle: {
      type: String,
      required: true
    }
  },
  computed: {
    rectangleWidth: function() {
      return (100 / this.nbSteps).toString() + '%'
    }
  },
  methods: {
    stepColor: function(stepIndex) {
      if (stepIndex <= this.step) {
        return '#7667a7'
      } else {
        return '#E0E0E0'
      }
    },
    getBorderLeft: function(stepIndex) {
      return stepIndex > 1 ? '5px' : '0px'
    },
    getBorderRight: function(stepIndex) {
      return stepIndex < this.nbSteps ? '5px' : '0px'
    }
  }
}
</script>
